import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Crest";

const COLS = [
  { title: "Institution", links: [["About", "/about"], ["Educational model", "/educational-model"], ["Leadership", "/leadership"], ["Faculty", "/faculty"], ["Research & student work", "/research"]] },
  { title: "Study", links: [["Schools", "/schools/accelerated-studies"], ["Programmes", "/programmes"], ["Admissions", "/admissions"], ["Tuition & scholarships", "/tuition"], ["From Africa", "/africa"]] },
  { title: "Engage", links: [["Apply", "/apply"], ["Parents & educators", "/parents"], ["Invest in Simo", "/invest"], ["Contact", "/contact"], ["Staff login", "/login"]] },
];

export function Footer() {
  return (
    <footer className="border-t border-border bg-ink text-paper mt-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div>
            <Wordmark white className="h-8 mb-5" />
            <p className="text-sm text-paper/60 leading-relaxed max-w-xs">
              The flagship and laboratory institution of the UBO education ecosystem, powered academically by Nucleus. Online-first, worldwide.
            </p>
            <p className="mt-4 font-serif italic text-paper/50">Lux Simonis Populis</p>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <div className="eyebrow text-heraldic mb-4">{c.title}</div>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-sm text-paper/70 hover:text-white transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-paper/50">
          <span>© 2026 Simo University. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/accessibility" className="hover:text-white">Accessibility</Link>
            <Link to="/safeguarding" className="hover:text-white">Safeguarding</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
